module.exports = __webpack_public_path__ + "static/img/88.7efa0e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/notice/88.png
// module id = JL30
// module chunks = 1